import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Role } from '../models/role.model';
import { UserConfigsService } from '../services/user-configs.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[inRole]',
    standalone: false
})
export class InRoleDirective implements OnDestroy, OnInit {
	private hasView = false;
	private destroy$ = new Subject<void>();
	private _inRoleNegative;
	private _roles: Role[];

	@Input()
	public set inRoleNegative(value: boolean) {
		this._inRoleNegative = value;
	}

	@Input()
	public set inRole(roles: Role[]) {
		if (roles instanceof Array)
			this._roles = roles;
		else
			this._roles = [roles];
	}

	constructor(private templateRef: TemplateRef<any>,
				private viewContainer: ViewContainerRef,
				private userConfigsService: UserConfigsService) {
	}

	ngOnDestroy(): void {
		this.destroy$.next();
	}

	ngOnInit(): void {
		this.userConfigsService.inRoles$(...this._roles).pipe(takeUntil(this.destroy$)).subscribe((result) => {
			let shouldShowContainer = result;
			if (this._inRoleNegative) {
				shouldShowContainer = !result;
			}

			if (shouldShowContainer && !this.hasView) {
				this.viewContainer.createEmbeddedView(this.templateRef);
				this.hasView = true;
			} else if (!shouldShowContainer && this.hasView) {
				this.viewContainer.clear();
				this.hasView = false;
			}
		});
	}
}
